<template>
	<div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 col-xl-10">
					<div class="row align-items-center justify-content-between">
						<div class="col-12 col-lg-4">
							<h4 class="mm-0 mb-4">Entities </h4>
						</div><!--col-->
					</div><!--row-->
				</div><!--col-->
			</div><!--row-->
			<div class="row">
				<div class="col-12 col-xl-10">
					<div class="table-responsive">

						<table class="table table-bordered">
							<thead>
								<tr>
									<th class="green-content">Name</th>
									<th class="green-content">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in entities">
									<td>{{ item.name }}</td>
									<td>
										<router-link :to="{ name: 'admin.configs.entities.taggables.detail', params : { id : item.id } }" tag="a" class="button">Manage groups</router-link>
									</td>
								</tr>
							</tbody>
						</table>
					</div>


					<div class="row justify-content-between ">
						<div class="col-12 col-lg-6">
							<span>Showing {{ pagination_data.from }} to {{ pagination_data.to }} of {{ pagination_data.total }}</span>
						</div><!--col-->
						<div class="col-12 col-lg-6">
							<b-pagination align="right" :total-rows="pagination_data.total" v-model="pagination_data.current_page" :per-page="parseInt(pagination_data.per_page)" @change="setPage">
		    				</b-pagination>
						</div><!--col-->
					</div><!--row-->					
				</div>
			</div>
	    </div>
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			pagination_data : {
				current_page : 1,
				total : 15,
				per_page  : 10,
				from : 0,
				to : 0
			},
			
			entities : []
		}
	},

	created : function(){
		this.getEntities();
	},

	methods : {

		getEntities : function() {

			var params = {
				filters : {
					page : this.current_page,
					per_page : this.per_page
				}
			}
			
			this.$store.dispatch('getEntitiesTaggables', params).then((res) => {
				this.entities = res.data.data;
				this.pagination_data = res.data.meta;
			}).catch((error) => {
				console.log(error);
			});
		},
		setPage : function(page){
			this.current_page = page;

			this.getEntities();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/configs/entities-taggables/AdminEntityTaggableListComponent.vue